import DrillDownView from './DrillDownView'

const DrillDownPage = ({ type }) => {
    return <DrillDownView type={type} />
}

export default DrillDownPage
